export enum GroupType {
  archivedLocation = 'archivedLocation',
  archivedPosition = 'archivedPosition',
  group = 'group',
  location = 'location',
  position = 'position',
  tag = 'tag',
}
